<template>
    <section class="testimonial-area-four section-padding section" :class="testimonialStyle" id="review">
        <div class="testimonial-top">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="section-title title-style-4 text-center">
                            <h2 class="title">Kliente te kenaqur</h2>
                            <p>Disa deshmi te klienteve tane.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="testimonial-bottom">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <carousel class="testimonial-active-four owl-dot-style"
                            :items = "3"
                            :nav = "false"
                            :dots = "false"
                            :smartSpeed = "1000"
                            :responsive="{0:{items:1},768:{items:2},1200:{items:3}}"
                        >
                            <div v-for="(client, clients) in clients" :key="clients" class="testimonial-item">
                                <div class="testimonial-thumb">
                                    <img :src="client.clientThumb" alt="client thumb">
                                </div>
                                <div class="testimonial-content">
                                    <h6 class="client">{{ client.name }}</h6>
                                    <p>{{ client.desc }}</p>
                                </div>
                            </div>
                        </carousel>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import carousel from 'vue-owl-carousel'
export default {
    name: 'TestimonialFour',
    components: { 
        carousel 
    },
    props: ["testimonialStyle"],
    data (){
        return {
            clients: [
                {
                    clientThumb: require("../assets/img/testimonial/fblogo.png"), 
                    name: "Klara B", 
                    designation: "", 
                    desc: "Me i miri, per profesionalizem, seriozitet, prezantim, pasterti. Vazhdoni punen tuaj fisnike dhe vetem suksese do te keni Helios Med."
                },
                {
                    clientThumb: require("../assets/img/testimonial/fblogo.png"), 
                    name: "Elona F", 
                    designation: "", 
                    desc: "Laboratori me I mire ne Fier ,super profesionalizem dhe doktoresha shume komunikuese dhe simpatike!"
                },
                {
                    clientThumb: require("../assets/img/testimonial/fblogo.png"), 
                    name: "Lida G", 
                    designation: "", 
                    desc: "Laborator bashkohore dhe teper i sakte ne analiza. I kam bere brenda javes analiza ne laboratorin tuaj si dhe ne USA dhe me kane dale njesoj parametrat."
                },
            ]
        }
    }
}
</script>

<style lang='scss'>
    @import '../assets/scss/variables.scss';
    @import '../assets/scss/components/testimonial.scss';
</style>
